// extracted by mini-css-extract-plugin
export default {"welcomePageHeader":"WelcomePageHeader_welcomePageHeader__GIQrT"};